module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('custom-input', {
    attrs: {
      "title": "Verstorbener"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deceaseds.model.name),
      expression: "deceaseds.model.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "deceased_name",
      "required": "required",
      "list": "deceased_list"
    },
    domProps: {
      "value": (_vm.deceaseds.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deceaseds.model.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "deceased_list"
    }
  }, _vm._l((_vm.$store.getters.models('deceaseds')), function(deceased) {
    return _c('option', [_vm._v(_vm._s(deceased.id) + ": " + _vm._s(deceased.lastname) + ", " + _vm._s(deceased.firstname))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f0bfa910!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer-deceased.vue
// module id = 466
// module chunks = 0